import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Herramientas", -1)
const _hoisted_2 = { class: "p-fluid tool-link" }
const _hoisted_3 = { class: "p-field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "firstname" }, "Slack", -1)
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "lastname" }, "Carpeta compartida", -1)
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "lastname" }, "Carpeta docente", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputLink = _resolveComponent("InputLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_InputLink, {
          readonly: "",
          value: _ctx.slack
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_InputLink, {
          readonly: "",
          value: _ctx.sharedFolder
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_InputLink, {
          readonly: "",
          value: _ctx.teacherFolder
        }, null, 8, ["value"])
      ])
    ])
  ], 64))
}